import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/files/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
};

export const track = (event, meta) => {
  try { api.post("/track", { event, meta }); } catch (e) {}
};

export const CATEGORIES = [
  { key: "antipasti", label: "Antipasti" },
  { key: "primi", label: "Primi piatti" },
  { key: "brace", label: "Secondi alla brace" },
  { key: "secondi", label: "Altri secondi" },
  { key: "contorni", label: "Contorni" },
  { key: "formaggi", label: "Formaggi" },
  { key: "dolci", label: "Dolci" },
  { key: "vini", label: "Vini e bevande" },
];

export const GALLERY_LABELS = {
  storiche: "Foto storiche",
  ambienti: "Gli ambienti",
  cucina: "La nostra cucina",
};
export const GALLERY_ORDER = ["storiche", "ambienti", "cucina"];
// Categorie storiche del DB → le tre categorie attuali
const GALLERY_LEGACY = { sala: "ambienti", esterno: "ambienti", eventi: "ambienti", ristorante: "ambienti", pasta: "cucina", piatti: "cucina", famiglia: "storiche" };
export const galleryCategory = (c) => GALLERY_LEGACY[c] || c;
export const isVideo = (path = "") => /\.(mp4|mov|webm|m4v)(\?|$)/i.test(path);

// Specialità escluse dalla panoramica del menù (restano nel menù completo)
export const SPECIALTY_EXCLUDE_IDS = [
  "ed2519de-47c9-4be6-8bb8-b1e8acde3807", // Cesto di crescentine
  "b4b6943b-a404-482a-b57e-d4c63eb445cf", // Coppa, salami, prosciutto
  "d058dd88-1e8b-4e7c-8347-42968910803a", // Crescentine e affettati
  "4e3292ef-54d5-42aa-81d6-9f9d52666503", // Tagliatelle con prosciutto
];
